function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.00008 1.91663V0.166626L2.66675 2.49996L5.00008 4.83329V3.08329C6.93091 3.08329 8.50008 4.65246 8.50008 6.58329C8.50008 8.31579 7.23425 9.75079 5.58341 10.0308V11.2091C7.88758 10.9233 9.66675 8.96329 9.66675 6.58329C9.66675 4.00496 7.57841 1.91663 5.00008 1.91663Z",
  fill: "#00AAE1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.50016 6.5834C1.50016 5.6209 1.891 4.7459 2.52683 4.11007L1.6985 3.28174C0.858496 4.12757 0.333496 5.29424 0.333496 6.5834C0.333496 8.9634 2.11266 10.9234 4.41683 11.2092V10.0309C2.766 9.7509 1.50016 8.3159 1.50016 6.5834Z",
  fill: "#00AAE1"
});

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.d826a7f6.svg";
export { ForwardRef as ReactComponent };